import { render, staticRenderFns } from "./Masterclass.vue?vue&type=template&id=ac86f79e&"
import script from "./Masterclass.vue?vue&type=script&lang=js&"
export * from "./Masterclass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports